<template>
  <div>
    <nav class="flex gap-x-4 justify-center mb-2">
      <!-- <button
        @click="setPage('all')"
        :class="
          activePage == 'all'
            ? 'p-2 border-2 bg-blue-100 border-blue-800 rounded-full  dark:bg-blue-700 dark:border-red-100 dark:text-white'
            : 'p-2 border-2 border-blue-800 rounded-full dark:border-white dark:text-white'
        "
      >
        All Pokemon
      </button>
      <button
        @click="setPage('m-a')"
        :class="
          activePage == 'm-a'
            ? 'p-2 border-2 bg-blue-100 border-blue-800 rounded-full dark:bg-blue-700 dark:border-white dark:text-white'
            : 'p-2 border-2 border-blue-800 rounded-full dark:border-white dark:text-white'
        "
      >
        Champions M-A
      </button>
      <button
        @click="setPage('m-b')"
        :class="
          activePage == 'm-b'
            ? 'p-2 border-2 bg-blue-100 border-blue-800 rounded-full dark:bg-blue-700 dark:border-white dark:text-white'
            : 'p-2 border-2 border-blue-800 rounded-full dark:border-white dark:text-white'
        "
      >
        Champions M-B
      </button>
      <button
        @click="setPage('m-c')"
        :class="
          activePage == 'm-c'
            ? 'p-2 border-2 bg-blue-100 border-blue-800 rounded-full dark:bg-blue-700 dark:border-white dark:text-white'
            : 'p-2 border-2 border-blue-800 rounded-full dark:border-white dark:text-white'
        "
      >
        Champions M-C
      </button> -->
      <label for="regulationDropdown" class="p-2">Regulation:</label>
      <select
        name="regulationDropdown"
        id="regulationDropdown"
        @change="setPage(null)"
        v-model="activePage"
        class="p-2 border-2 border-blue-800 rounded"
      >
        <option value="all">All (NatDex)</option>
        <option value="m-a">M-A</option>
        <option value="m-b">M-B</option>
        <option value="m-c">M-C</option>
      </select>
    </nav>
    <img
      src="/android-chrome-192x192.png"
      alt="Muted Pokeball colors with an arrow pointing upwards along the bottom right cuve of the ball to represent upping your pokemon's stats."
      class="mx-auto"
    />
    <h1 class="text-4xl font-bold mb-4">Champions Speed Data</h1>
    <p class="mb-2">
      Start typing a pokemon's name to filter the list!<br />You can use the
      pipe (|) character to chain searches!
    </p>

    <VueFuse
      :fuse-opts="opts"
      :keys="['name']"
      :list="pokemon"
      @fuse-results="handleResults"
      class="my-4 mx-auto p-4 text-xl border-2 rounded mr-4 bg-transparent"
    />

    <table
      class="mx-auto font-light md:font-bold text-sm md:text-lg dark:text-white"
    >
      <tr class="sticky top-0 bg-white dark:bg-gray-800">
        <th class="font-light md:font-bold"></th>
        <th class="font-light md:font-bold">Pokemon</th>
        <th class="font-light md:font-bold">Min Speed</th>
        <th class="font-light md:font-bold">Base Speed</th>
        <th class="font-light md:font-bold">+32 SP</th>
        <th class="font-light md:font-bold">Max Speed</th>
        <th class="font-light md:font-bold">Scarf</th>
      </tr>
      <tr v-for="(poke, index) in pokeResults" :key="index" class="my-2">
        <td class="p-2">
          <img
            :src="'/sprites/' + poke.item.dex + '.png'"
            :alt="'Sprite for ' + poke.item.name"
            @error="handleImageError"
            width="96px"
          />
        </td>
        <td class="p-2">
          {{ toTitleCase(poke.item.name.split("-").join(" ")) }}
        </td>
        <td class="p-2 h-8 w-8 md:w-20 bg-red-200 dark:bg-red-900">
          {{ Math.floor((poke.item.speed + 20) * 0.9) * multiplier }}
        </td>
        <td class="p-2 w-8 md:w-20 bg-yellow-200 dark:bg-yellow-900">
          {{ (poke.item.speed + 20) * multiplier }}
        </td>
        <td class="p-2 w-8 md:w-20 bg-purple-200 dark:bg-purple-900">
          {{ (poke.item.speed + 52) * multiplier }}
        </td>
        <td class="p-2 w-8 md:w-20 bg-green-200 dark:bg-green-900">
          {{ Math.floor((poke.item.speed + 52) * 1.1) * multiplier }}
        </td>
        <td class="p-2 w-8 md:w-20 bg-blue-200 dark:bg-blue-900">
          {{
            poke.item.name.includes("-mega")
              ? "--"
              : Math.floor(Math.floor((poke.item.speed + 52) * 1.1) * 1.5) *
                multiplier
          }}
        </td>
      </tr>
    </table>
    <button
      @click="togglemult()"
      class="rounded-full w-12 h-12 fixed right-4 bottom-4 bg-blue-100 filter drop-shadow opacity-90 lg:opacity-100 dark:bg-blue-700 dark:text-white"
    >
      x{{ multiplier }}
    </button>
  </div>
</template>

<script>
import axios from "axios";
import VueFuse from "vue-fuse";

export default {
  name: "App",
  components: {
    VueFuse,
  },
  data() {
    return {
      pokemon: [],
      pokeResults: [],
      opts: {
        keys: ["name", "speed"],
        useExtendedSearch: true,
        threshold: 0.4,
      },
      activePage: "m-c",
      multiplier: 1,
    };
  },
  mounted() {
    axios.get("/champs-m-c.json").then((res) => {
      this.pokemon = Object.values(res.data);
    });
  },
  methods: {
    handleResults(r) {
      // Don't modify r directly, use Array.from to prevent infinite loops
      this.pokeResults = Array.from(r).sort((a, b) => {
        return b.item.speed - a.item.speed;
      });
    },
    // eslint-disable-next-line
    setPage(toPage) {
      if (toPage) {
        this.activePage = toPage;
      }
      if (this.activePage == "all") {
        axios.get("/all.json").then((res) => {
          this.pokemon = Object.values(res.data);
        });
        // } else if (this.activePage == "m-a") {
        //   axios.get("/champs-m-a.json").then((res) => {
        //     this.pokemon = Object.values(res.data);
        //   });
        // } else if (this.activePage == "m-b") {
        //   axios.get("/champs-m-b.json").then((res) => {
        //     this.pokemon = Object.values(res.data);
        //   });
        // } else if (this.activePage == "m-c") {
        //   axios.get("/champs-m-c.json").then((res) => {
        //     this.pokemon = Object.values(res.data);
        //   });
      } else {
        axios.get(`/champs-${this.activePage}.json`).then((res) => {
          this.pokemon = Object.values(res.data);
        });
      }
    },
    toTitleCase(str) {
      return str.replace(
        /\w\S*/g,
        (text) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
      );
    },
    handleImageError(evt) {
      evt.target.src = "/sprites/0.png";
    },
    togglemult() {
      if (this.multiplier == 1) {
        this.multiplier = 2;
      } else {
        this.multiplier = 1;
      }
    },
  },
};
</script>
